import React from "react";

import { Router } from "../../../router";

function App() {
  return (
    <div className="app-container">
      <Router />
    </div>
  );
}

export default App;
